import * as api from "../api/index";
import {
  CHECK_BILLING_CYCLE,
  CREATE_BILLING_CYCLE,
  END_LOADING,
  FETCH_ALL_BILLING_CYCLE,
  FETCH_DAILY_PAYMENTS,
  FETCH_ONE_BILLING_CYCLE,
  START_LOADING,
} from "./constants";

export const getBillingCyclesAction = (user) => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING });
    const { data } = await api.getBillingCycle(user);

    dispatch({ type: FETCH_ALL_BILLING_CYCLE, payload: data });
    dispatch({ type: END_LOADING });
  } catch (error) {
    console.log(error.response);
  }
};
export const getBillingCyclesByAssistantAction =
  (assistant) => async (dispatch) => {
    try {
      dispatch({ type: START_LOADING });
      const { data } = await api.getBillingCycleByAssistant({ assistant });

      dispatch({ type: FETCH_ALL_BILLING_CYCLE, payload: data });
      dispatch({ type: END_LOADING });
    } catch (error) {
      console.log(error.response);
    }
  };

export const createBillingCycleAction =
  (formData, history) => async (dispatch) => {
    try {
      dispatch({ type: START_LOADING });
      const { data } = await api.createBillingCycle(formData);

      dispatch({ type: CREATE_BILLING_CYCLE, payload: data });

      dispatch({ type: FETCH_ONE_BILLING_CYCLE, payload: data });

      dispatch({ type: END_LOADING });
      history.push("/billing-cycle/" + data._id);
    } catch (error) {
      dispatch({ type: END_LOADING });
      console.log(error);
    }
  };
export const getDailyPaymentsAction = (id) => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING });
    const { data } = await api.getDailyPayments(id);

    dispatch({ type: FETCH_DAILY_PAYMENTS, payload: data });
    dispatch({ type: END_LOADING });
  } catch (error) {
    console.log(error.response);
  }
};
export const getBillingCycleAction = (id) => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING });

    const { data } = await api.getOneBillingCycle(id);

    dispatch({ type: FETCH_ONE_BILLING_CYCLE, payload: data });
    dispatch({ type: END_LOADING });
  } catch (error) {
    console.log(error.response);
  }
};
export const checkBillingCycleAction =
  (id, setButtonStatus) => async (dispatch) => {
    try {
      setButtonStatus("loading");
      dispatch({ type: START_LOADING });

      await api.checkBillingCycle({ id });

      dispatch({ type: CHECK_BILLING_CYCLE, payload: id });
      dispatch({ type: END_LOADING });
      setButtonStatus("success");
    } catch (error) {
      console.log(error.response);
    }
  };
